module.exports = __webpack_public_path__ + "static/MiguelB-7835e7b92e8fdfd1bf574abc91b77c7a.gif";